import PropTypes from 'prop-types'
import React from 'react'
import { receptionDeskAdditionalConfigOptions } from '../../../configs/officeHourConfig'
import AdditionalConfig from './AdditionalConfig'

const ReceptionDeskAdditionalConfig = ({ enabled }) => {
  return (
    <AdditionalConfig
      name="reception_desk_additional_config"
      label="Configuración adicional"
      hint="El horario de atención de la Mesa de partes:"
      optionsSource={receptionDeskAdditionalConfigOptions}
      enabled={enabled}
      isReceptionDesk
    />
  )
}

export default ReceptionDeskAdditionalConfig

ReceptionDeskAdditionalConfig.propTypes = {
  enabled: PropTypes.bool
}
